import { Component } from '@angular/core';
import { TestimonialCardComponent } from './testimonial-card/testimonial-card.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { testimonials } from '../../constants-monisfer-infos';

@Component({
  selector: 'app-testimonials',
  imports: [TestimonialCardComponent, MatProgressSpinnerModule],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss',
})
export class TestimonialsComponent {
  readonly testimonials = testimonials;
}
